import React from 'react';

import MijnGegevens from '../../components/authentication/user/MijnGegevens';

const PageMijnGegevens: React.FC = () => {

  return (
    <>
      <header className="app-header">
        <h1>Mijn gegevens</h1>
        <p className="header-sub-title">Een overzicht van mijn gegevens.</p>
      </header>

      <div className="container content content-750 text-left">
        <MijnGegevens />
      </div>
    </>
  );
};

export default PageMijnGegevens;